import { useEffect, useState } from "react";
import CRM_API from "../../api/crmApi";

export default function CrmManageUsers() {
  const [employees, setEmployees] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [fullName, setFullName] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("counsellor");
  const [showPassword, setShowPassword] = useState(false);

  const currentUserId = parseInt(localStorage.getItem("crm_user_id"), 10);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchEmployees(); }, []);

  const fetchEmployees = async () => {
    try {
      const res = await CRM_API.get("/dashboard/all-employees");
      setEmployees(res.data);
    } catch (error) { console.log("Error loading employees", error); }
  };

  const createUser = async () => {
    try {
      await CRM_API.post("/auth/register", { full_name: fullName, mobile, password, role });
      alert("Employee created successfully");
      setShowModal(false);
      setFullName(""); setMobile(""); setPassword(""); setRole("counsellor");
      fetchEmployees();
    } catch (err) {
      alert(err.response?.data?.detail || "Failed to create employee");
    }
  };

  const deleteUser = async (id, name) => {
    if (!window.confirm(`Delete "${name}"? This cannot be undone.`)) return;
    try {
      await CRM_API.delete(`/users/${id}`);
      fetchEmployees();
    } catch (error) {
      alert(error.response?.data?.detail || "Failed to delete user");
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setFullName(""); setMobile(""); setPassword(""); setRole("counsellor");
  };

  return (
    <div>

      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="fw-bold mb-0">Employees</h4>
        <button onClick={() => setShowModal(true)} className="btn btn-primary">
          <i className="bi bi-person-plus me-2" />+ Add Employee
        </button>
      </div>

      {/* Employee Cards */}
      <div className="row g-4">
        {employees.map((emp) => {
          const initial = emp.full_name?.charAt(0).toUpperCase();
          const rate = emp.total_leads
            ? Math.round((emp.converted / emp.total_leads) * 100)
            : 0;
          const isSelf = emp.id === currentUserId;

          return (
            <div key={emp.id} className="col-md-4 col-lg-4">
              <div
                className="card h-100"
                style={{ borderRadius: "14px", border: "1px solid #e5e7eb", boxShadow: "0 1px 6px rgba(0,0,0,.06)" }}
              >
                <div className="card-body p-4">

                  {/* Avatar + Name */}
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div style={{
                      width: 48, height: 48, borderRadius: "50%", flexShrink: 0,
                      background: "#e0e7ff", display: "flex", alignItems: "center",
                      justifyContent: "center", fontWeight: 700, fontSize: "18px", color: "#4f46e5",
                    }}>
                      {initial}
                    </div>
                    <div>
                      <h6 className="mb-0 fw-semibold">
                        {emp.full_name}
                        {isSelf && (
                          <span className="ms-2" style={{ fontSize: "11px", color: "#3b82f6" }}>(you)</span>
                        )}
                      </h6>
                      <p className="mb-0 text-muted" style={{ fontSize: "13px" }}>{emp.mobile}</p>
                    </div>
                  </div>

                  {/* Role badge */}
                  <span style={{
                    display: "inline-block",
                    padding: "3px 10px", borderRadius: "999px",
                    fontSize: "12px", fontWeight: 500, marginBottom: "14px",
                    background: emp.role === "admin" ? "#f3e8ff" : "#dbeafe",
                    color: emp.role === "admin" ? "#7c3aed" : "#1d4ed8",
                  }}>
                    {emp.role}
                  </span>

                  <hr style={{ margin: "0 0 14px" }} />

                  {/* Stats */}
                  <div className="d-flex justify-content-between mb-3">
                    <div>
                      <p className="text-muted mb-1" style={{ fontSize: "12px" }}>Leads</p>
                      <p className="fw-bold mb-0">{emp.total_leads}</p>
                    </div>
                    <div>
                      <p className="text-muted mb-1" style={{ fontSize: "12px" }}>Converted</p>
                      <p className="fw-bold mb-0" style={{ color: "#16a34a" }}>{emp.converted}</p>
                    </div>
                    <div>
                      <p className="text-muted mb-1" style={{ fontSize: "12px" }}>Rate</p>
                      <p className="fw-bold mb-0" style={{ color: "#4f46e5" }}>{rate}%</p>
                    </div>
                  </div>

                  {/* Delete button */}
                  {!isSelf && (
                    <button
                      onClick={() => deleteUser(emp.id, emp.full_name)}
                      className="btn btn-sm w-100"
                      style={{ background: "#fee2e2", color: "#dc2626", border: "none", borderRadius: "8px" }}
                    >
                      <i className="bi bi-trash me-1" />Delete
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Create Employee Modal */}
      {showModal && (
        <div
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,.45)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 1055,
          }}
          onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
        >
          <div style={{
            background: "#fff", borderRadius: "16px", padding: "32px",
            width: "100%", maxWidth: "400px", boxShadow: "0 20px 60px rgba(0,0,0,.2)",
          }}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h5 className="fw-bold mb-0">Create Employee</h5>
              <button
                onClick={closeModal}
                style={{ background: "none", border: "none", fontSize: "20px", color: "#9ca3af", cursor: "pointer", lineHeight: 1 }}
              >
                &times;
              </button>
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold" style={{ fontSize: "13px" }}>Full Name</label>
              <input
                className="form-control"
                placeholder="Full Name"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold" style={{ fontSize: "13px" }}>Mobile</label>
              <input
                className="form-control"
                placeholder="Mobile number"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold" style={{ fontSize: "13px" }}>Password</label>
              <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i className={`bi bi-eye${showPassword ? "-slash" : ""}`} />
                </button>
              </div>
            </div>
            <div className="mb-4">
              <label className="form-label fw-semibold" style={{ fontSize: "13px" }}>Role</label>
              <select className="form-select" value={role} onChange={(e) => setRole(e.target.value)}>
                <option value="counsellor">Counsellor</option>
                <option value="admin">Admin</option>
              </select>
            </div>

            <div className="d-flex gap-3">
              <button onClick={closeModal} className="btn btn-light flex-fill">Cancel</button>
              <button onClick={createUser} className="btn btn-primary flex-fill">Create</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
